import React, { Component, useState } from "react";
import { inject, observer } from "mobx-react";
import styles from "./bloodStationsPage.module.scss";
import plural from "plural-ru";
import { NextRouter, withRouter } from "next/router";
import ResourseStore from "../../stores/ResourseStore";
import BloodStationStore from "../../stores/BloodStationStore";
import SelectedCityStore from "../../stores/SelectedCityStore";
import AuthStore from "../../stores/AuthStore";
import { City } from "../../entities";
import SearchPanel from "../bloodStationsSearcher";
import { IBSPlank } from "../bloodStations/interfaces";
import Spinner from "../spinner";
import { Ymaps } from "../bloodStations/ymaps";
import {
  getUserCityByCoords,
  removeFalsyPropValueFromObj,
  sendMetrics,
} from "../../utils/misc";
import redirectTo from "../../utils/redirectTo";
import SpinnerStore from "../../stores/SpinnerStore";
import ErrorPage from "../errorBoundary/errorPage";
import { NeedComponent } from "../mainPageBlocks/bloodStationsNeed/bloodStationsNeed";
import BlockContainer from "../mainPageBlocks/blockContainer";
import CustomCarousel from "../ui/customCarousel";
import UiStore from "../../stores/UiStore";

@inject("citiesStore")
@inject("bloodStationsStore")
@inject("selectedCityStore")
@inject("authStore")
@inject("spinnerStore")
@inject("uiStore")
@observer
class BloodStationsPage extends Component {
  props: {
    citiesStore?: ResourseStore;
    bloodStationsStore?: BloodStationStore;
    selectedCityStore?: SelectedCityStore;
    authStore?: AuthStore;
    initialSlug?: string;
    isDefault?: boolean;
    spinnerStore?: SpinnerStore;
    uiStore?: UiStore
    router: NextRouter;
  };

  state: {
    bloodStations: IBSPlank[] | null;
    isFilterOpen: boolean;
    totalBSCount: number;
    isRegistration: boolean;
    isHonoraryDonor: boolean;
    isTyped: boolean;
    isSunday: boolean;
    isSaturday: boolean;
    defaultCity: City | null;
    isRegistrationChanged: boolean;
    isHonoraryDonorChanged: boolean;
    isTypedChanged: boolean;
    isSundayChanged: boolean;
    isSaturdayChanged: boolean;
    mobileIsMap: boolean;
    loaded: boolean;
    mobileState: string;
    mobileOpenedPopup: boolean;
    mobilePopupInfo: any;
    isMapLoaded: boolean;
    filters?: {
      blood_group?: boolean;
      without_registration?: boolean;
      with_typing?: boolean;
      for_moscow?: boolean;
    };
    mapBounds: number[][];
    currentMapBounds: number[][];
    error?: boolean;
    isOpenFilterMobile: boolean;
  };
  private readonly mapRef: any;
  private readonly mobileMapRef: any;
  private readonly placemarkRefs: any[];

  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.mobileMapRef = React.createRef();
    this.placemarkRefs = [];

    this.state = {
      bloodStations: null,
      totalBSCount: 0,
      isFilterOpen: false,
      isRegistration: false,
      isHonoraryDonor: false,
      isTyped: false,
      isSunday: false,
      isSaturday: false,
      defaultCity: null,
      isRegistrationChanged: false,
      isHonoraryDonorChanged: false,
      isTypedChanged: false,
      isSundayChanged: false,
      isSaturdayChanged: false,
      mobileIsMap: false,
      mobileState: "list",
      mobileOpenedPopup: false,
      loaded: false,
      mobilePopupInfo: null,
      isMapLoaded: false,
      filters: null,
      error: false,
      mapBounds: [
        [55.63461550001277, 37.48056732177734],
        [55.87353659808905, 37.73805938720702],
      ],
      isOpenFilterMobile: false
    };
  }

  updateAfterFiltersApply = () => {
    if (!this.state.currentMapBounds) {
      this.setState({ currentMapBounds: this.state.mapBounds });
    }
    this.setState({
      mapBounds: this.state.currentMapBounds,
    });
    this.props.bloodStationsStore
      .getBloodStationsByBounds(
        this.state.mapBounds || this.state.currentMapBounds,
        this.state.filters
      )
      .then((r) => {
        const sortedR = r.sort(this.sortByCity)
        this.setState({
          bloodStations: sortedR,
        });
      })
      .catch((er) => {
        console.error(er);
      });
  };

  updateFilters = () => {
    const { isRegistration, isHonoraryDonor, isTyped, isSunday, isSaturday } = this.state;
    const filters = {
      without_registration: isRegistration || undefined,
      with_typing: isTyped || undefined,
      open_on_sunday: isSunday || undefined,
      open_on_saturday: isSaturday || undefined,
      for_moscow: isHonoraryDonor || undefined,
      blood_group: this.props.authStore?.user?.blood_group || undefined,
    };
    this.setState(
      {
        filters: removeFalsyPropValueFromObj(filters),
      },
      this.updateAfterFiltersApply
    );
  };

  loadStationsByCityId = (city_id: number) => {
    this.props.bloodStationsStore
      .filter({ ...this.state.filters, city_id: city_id, closed: false })
      .then((items) => {
        this.setState({
          totalBSCount: items.length,
        });
      })
      .catch(() => {
        this.setState({
          error: true,
        });
      });
  };

  loadCityByIdentifier = (identifier: number | string) => {
    if (this.props.isDefault) {
      this.loadStationsByDefault();
    } else {
      this.props.citiesStore
        .loadOne(identifier, this.state.filters)
        .then((r) => {
          if (r.slug && r.slug !== identifier)
            redirectTo(`/bloodstations/${r.slug}`);
          this.setState({
            mapBounds: [
              [r.lat - 0.28493968, r.lng - 0.849181551],
              [r.lat + 0.279444267, r.lng + 0.826233488],
            ],
            defaultCity: r,
            isMapLoaded: true,
            loaded: true,
          });
          this.loadStationsByCityId(r.id);
          this.onBoundsChange({
            current: {
              _bounds: [
                [r.lat - 0.28493968, r.lng - 0.849181551],
                [r.lat + 0.279444267, r.lng + 0.826233488],
              ]
            },
          });
        })
        .catch(() => {
          this.setState({
            error: true,
          });
        });
    }
    this.props.spinnerStore.toggleSpinner();
  };

  loadStationsByDefault = () => {
    this.props.bloodStationsStore
      .getBloodStationsByBounds(this.state.mapBounds, this.state.filters)
      .then((r) => {
        const sortedR = r.sort(this.sortByCity)
        this.setState({
          bloodStations: sortedR,
          loaded: true,
          isMapLoaded: true,
          totalBSCount: r.length,
        });
      })
      .catch(() => {
        this.setState({
          error: true,
        });
      });
  };

  focusOnPathNameQuery = () => {
    const bsID = this.props.router?.query?.bsID;
    this.props.bloodStationsStore
      .loadOne(bsID)
      .then((r) => {
        this.mobileChangeState("map");
        this.setState({
          bloodStations: [r],
          mapBounds: [
            [r.lat + 0.012025032839955685, r.lng - 0.014485492163090186],
            [r.lat - 0.012157620759683141, r.lng + 0.012190685815424018],
          ],
          defaultCity: r.city,
          loaded: true,
          totalBSCount: [r].length,
        });
        this.mobileOpenPopup({
          balloonContentHeader: r.title,
          balloonContentBody: r.address,
          objectId: r.id,
        });
      })
      .catch(() => {
        this.setState({
          error: true,
        });
      });
    this.props.spinnerStore.toggleSpinner();
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("guest-page")) {
      this.setState({
        mobileIsMap: false,
        mobileOpenedPopup: false,
        mobileState: "search",
      });
    }
    this.props.spinnerStore.toggleSpinner();
    if (
      this.props.router?.query?.bsID &&
      this.props.router?.query?.bsID !== "undefined"
    ) {
      this.focusOnPathNameQuery();
      return;
    }
    this.loadCityByIdentifier(this.props.initialSlug);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialSlug !== this.props.initialSlug) {
      this.props.spinnerStore.toggleSpinner();
      this.mobileChangeState("map");
      this.loadCityByIdentifier(this.props.initialSlug);
    }
  }

  openFilters = (event) => {
    event.stopPropagation();
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
      isRegistrationChanged: false,
      isHonoraryDonorChanged: false,
      isTypedChanged: false,
      isSundayChanged: false,
      isSaturdayChanged: false,
    });
  };

  registrationChange = () => {
    this.setState(
      {
        isRegistration: !this.state.isRegistration,
        isRegistrationChanged: true,
      },
      this.updateFilters
    );
  };

  honoraryDonorChange = () => {
    this.setState(
      {
        isHonoraryDonor: !this.state.isHonoraryDonor,
        isHonoraryDonorChanged: true,
      },
      this.updateFilters
    );
  };

  typedChange = () => {
    this.setState(
      {
        isTyped: !this.state.isTyped,
        isTypedChanged: true,
      },
      this.updateFilters
    );
  };

  sundayChange = () => {
    this.setState(
      {
        isSunday: !this.state.isSunday,
        isSundayChanged: true,
      },
      this.updateFilters
    );
  };

  saturdayChange = () => {
    this.setState(
      {
        isSaturday: !this.state.isSaturday,
        isSaturdayChanged: true,
      },
      this.updateFilters
    );
  };

  calculateFiltersCount = () => {
    let count = 0;
    const { isRegistration, isTyped, isHonoraryDonor, isSunday, isSaturday } = this.state;
    if (isRegistration) count++;
    if (isTyped) count++;
    if (isHonoraryDonor) count++;
    if (isSunday) count++;
    if (isSaturday) count++;
    return count;
  };

  scrollMapTo = (r) => {
    this.setState({
      mapBounds: [
        [parseFloat(r.lat) + 0.01, parseFloat(r.lng) - 0.01],
        [parseFloat(r.lat) - 0.01, parseFloat(r.lng) + 0.01],
      ],
    });
  };

  agreeFilters = () => {
    sendMetrics("use_bs_filters");
    this.setState(
      {
        isFilterOpen: false,
        isRegistration: this.state.isRegistration,
        isTyped: this.state.isTyped,
        isSunday: this.state.isSunday,
        isSaturday: this.state.isSaturday,
        isHonoraryDonor: this.state.isHonoraryDonor,
        mobileState: "map",
      },
      this.updateFilters
    );
  };

  disAgreeFilters = () => {
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
      isRegistration: this.state.isRegistrationChanged
        ? !this.state.isRegistration
        : this.state.isRegistration,
      isTyped: this.state.isTypedChanged
        ? !this.state.isTyped
        : this.state.isTyped,
      isSunday: this.state.isSundayChanged
      ? !this.state.isSunday
      : this.state.isSunday,
      isSaturday: this.state.isSaturdayChanged
      ? !this.state.isSaturday
      : this.state.isSaturday,
      isHonoraryDonor: this.state.isHonoraryDonorChanged
        ? !this.state.isHonoraryDonor
        : this.state.isHonoraryDonor,
      mobileState: "map",
    });
  };

  clearFilters = () => {
    this.setState(
      {
        isRegistration: false,
        isTyped: false,
        isSunday: false,
        isSaturday: false,
        isHonoraryDonor: false,
        isFilterOpen: !this.state.isFilterOpen,
        mobileState: "map",
      },
      this.updateFilters
    );
  };

  mobileChangeState = (state: string) => {
    if (state === "map")
      this.setState({
        mobileIsMap: true,
        mobileOpenedPopup: false,
        isMapLoaded: false,
        mobileState: state,
      });
    if (state === "list")
      this.setState({
        mobileIsMap: false,
        mobileOpenedPopup: false,
        mobileState: state,
      });
    if (state === "filters")
      this.setState({
        mobileIsMap: true,
        mobileOpenedPopup: false,
        mobileState: state,
        isRegistrationChanged: false,
        isHonoraryDonorChanged: false,
        isTypedChanged: false,
        isSundayChanged: false,
        isSaturdayChanged: false,
      });
    if (state === "search")
      this.setState({
        mobileIsMap: false,
        mobileOpenedPopup: false,
        mobileState: state,
      });
  };

  mobileOpenPopup = (info) => {
    this.setState({
      mobileOpenedPopup: true,
      mobilePopupInfo: info,
    });
  };

  mobileClosePopup = () => {
    this.setState({
      mobileOpenedPopup: false,
    });
  };

  mapLoaded = () => {
    this.setState({
      isMapLoaded: true,
    });
  };

  roundBounds = (e, isBig = false) => {
    if (e) {
      let [[x0, y0], [x1, y1]] = e;
      if (isBig) {
        return [
          [Number(x0.toFixed(3)) - 0.9, Number(y0.toFixed(3)) - 0.9],
          [Number(x1.toFixed(3)) + 0.9, Number(y1.toFixed(3)) + 0.9],
        ];
      }
      return [
        [Number(x0.toFixed(3)) - 1, Number(y0.toFixed(3)) - 1],
        [Number(x1.toFixed(3)), Number(y1.toFixed(3))],
      ];
    } else return e;
  };

  sortByCity = (a, b) => {
    if(a?.city?.title === this.state.defaultCity?.title && b?.city?.title !== this.state.defaultCity?.title) {
      return -1;
    } else if (a?.city?.title !== this.state.defaultCity?.title && b?.city?.title === this.state.defaultCity?.title) {
      return 1;
    } else {
      return 0;
    }
  }

  onBoundsChange = (e, fromState = false, rounded = false) => {
    let bounds = e?.current?._bounds;
    this.setState({ currentMapBounds: e?.current?._bounds });
    if (fromState) bounds = this.state.mapBounds;
    if (rounded) bounds = e?.current?._bounds;
    this.setState({
      loaded: false,
    });
    this.props.bloodStationsStore
      .getBloodStationsByBounds(bounds, this.state.filters)
      .then((r) => {
        const sortedR = r.sort(this.sortByCity)
        this.setState({
          bloodStations: sortedR,
          loaded: true,
        });
      })
      .catch(() => {
        this.setState({
          loaded: true,
          error: true,
        });
      });
  };

  mapGeolocationClick = () => {
    getUserCityByCoords(this.props.citiesStore)
      .then((r) => {
        this.setState({
          mapBounds: [
            [r.lat + 0.12025032839955685, r.lng - 0.14485492163090186],
            [r.lat - 0.12157620759683141, r.lng + 0.12190685815424018],
          ],
          defaultCity: r,
        });
        this.onBoundsChange({
          current: {
            _bounds: this.roundBounds(
              [
                [r.lat, r.lng],
                [r.lat, r.lng],
              ],
              true
            ),
          },
        });
      })
      .catch(() => {});
  };

  boundsMoving = (e) => {
    this.onBoundsChange(e, false, true);
  };

  fromMobileListToMap = (r) => {
    this.mobileChangeState("map");
    this.setState({
      mapBounds: [
        [r.lat + 0.012025032839955685, r.lng - 0.014485492163090186],
        [r.lat - 0.012157620759683141, r.lng + 0.012190685815424018],
      ],
    });
    this.mobileOpenPopup({
      balloonContentHeader: r.title,
      balloonContentBody: r.address,
      objectId: r.id,
    });
  };

  responsive = {
    superLargeDesktop: {
      breakpoint: { max: 3000, min: 1920 },
      items: 4,
      slidesToSlide: 4,
    },
    desktop: {
      breakpoint: { max: 1919, min: 1440 },
      items: 3,
      slidesToSlide: 3,
    },
    laptop: {
      breakpoint: { max: 1439, min: 1200 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1199, min: 768 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 360 },
      items: 1,
      slidesToSlide: 1,
    },
  }

  showOnCart = (r) => {
    this.setState({
      mapBounds: [
        [r.lat + 0.012025032839955685, r.lng - 0.014485492163090186],
        [r.lat - 0.012157620759683141, r.lng + 0.012190685815424018],
      ],
    });

    setTimeout(() => {
      this.placemarkRefs.forEach((placemarkRef) => {
        if (placemarkRef && placemarkRef.properties._data.objectId === r.id) {
          placemarkRef.balloon.open(); 
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        }
      });
    }, 300);
  }

  content = (bloodStations) => {
    let preContent;
    preContent = bloodStations.map((need) => (
      <NeedComponent need={{data: need}} key={need.id} showOnCart={this.showOnCart} isInCart/>
    ));

    return preContent;
  };

  render() {
    const {
      bloodStations,
      isFilterOpen,
      isRegistration,
      defaultCity,
      isHonoraryDonor,
      isTyped,
      isSunday,
      isSaturday,
      mobileIsMap,
      mobilePopupInfo,
      mobileOpenedPopup,
      filters,
      loaded,
      isMapLoaded,
      mapBounds,
      mobileState,
      error,
    } = this.state;
    const isMoscow = defaultCity?.id === 1;
    const { isDefault, router } = this.props;

    if (error) {
      return <ErrorPage />;
    }
    if (!this.props.spinnerStore.stateSpinner)
      return (
        <>
          {/* <MobileBloodStations
            bsID={router?.query?.bsID}
            fromMobileListToMap={this.fromMobileListToMap}
            bloodStations={bloodStations}
            mobileMapRef={this.mobileMapRef}
            filters={filters}
            mapLoaded={this.mapLoaded}
            mobileOpenPopup={this.mobileOpenPopup}
            mobileIsMap={mobileIsMap}
            mobileChangeState={this.mobileChangeState}
            honoraryDonorChange={this.honoraryDonorChange}
            isHonoraryDonor={isHonoraryDonor}
            isRegistration={isRegistration}
            isTyped={isTyped}
            registrationChange={this.registrationChange}
            typedChange={this.typedChange}
            isDefault={isDefault}
            isMoscow={isMoscow}
            agreeFilters={this.agreeFilters}
            boundsMoving={this.boundsMoving}
            calculateFiltersCount={this.calculateFiltersCount}
            clearFilters={this.clearFilters}
            defaultCity={defaultCity}
            disAgreeFilters={this.disAgreeFilters}
            isMapLoaded={isMapLoaded}
            loaded={loaded}
            mapBounds={mapBounds}
            mapGeolocationClick={this.mapGeolocationClick}
            mobileClosePopup={this.mobileClosePopup}
            mobileOpenedPopup={mobileOpenedPopup}
            mobilePopupInfo={mobilePopupInfo}
            mobileState={mobileState}
            content={this.content}
            responsive={this.responsive}
          /> */}
          <div className={styles.BloodStations}>
            <div className={styles.BloodStations_Div}>
              <div className="container">
              <div className={styles.BloodStations_Div_Top}>
                <div className={styles.BloodStations_Div_Left_Block_Search}>
                  {(defaultCity?.id || isDefault) && (
                    <SearchPanel
                      filters={filters}
                      defaultCity={defaultCity}
                    />
                  )}
                </div>
                <div
                  className={styles.BloodStations_Div_Left_Block_Filters}
                >
                  {
                    this.props.uiStore?.isMobile ? 
                    <MobileFilter
                      bloodStations={bloodStations}
                      isRegistration={isRegistration}
                      registrationChange={this.registrationChange}
                      isTyped={isTyped}
                      typedChange={this.typedChange}
                      isSaturday={isSaturday}
                      saturdayChange={this.saturdayChange}
                      isSunday={isSunday}
                      sundayChange={this.sundayChange}
                      isMoscow={isMoscow}
                      isHonoraryDonor={isHonoraryDonor}
                      honoraryDonorChange={this.honoraryDonorChange}
                      clearFilters={this.clearFilters}
                    />
                    :
                    <div
                      className={
                        styles.BloodStations_Div_Left_Block_Filters_Block
                      }
                    >
                      <div
                        className={
                          styles.BloodStations_Div_Left_Block_Filters_Block_Header
                        }
                      >
                        <div
                          className={
                            styles.BloodStations_Div_Left_Block_Filters_Block_Header_Selected
                          }
                        >
                          {bloodStations && bloodStations?.length ? (
                            <span>
                              {plural(
                                bloodStations.length,
                                "Центр крови",
                                "Центра крови",
                                "Центров крови"
                              )}
                              <span> {bloodStations.length}</span>
                            </span>
                          ) : (
                            <span>
                              Центров крови <span>0</span>
                            </span>
                          )}
                        </div>
                        <div
                          onClick={this.clearFilters}
                          className={
                            styles.BloodStations_Div_Left_Block_Filters_Block_Header_Clean
                          }
                        >
                          <span>Сбросить фильтры</span>
                        </div>
                      </div>
                      <div className={styles.BloodStations_Div_Left_Block_Filters_List}>
                        <div
                          className={
                            styles.BloodStations_Div_Left_Block_Filters_Block_Check
                          }
                        >
                          <CheckList
                            id={"isRegistration"}
                            name={"isRegistration"}
                            checked={isRegistration}
                            text={"Можно сдавать без прописки"}
                            type={"checkbox"}
                            onChange={this.registrationChange}
                          />
                        </div>
                        <div
                          className={
                            styles.BloodStations_Div_Left_Block_Filters_Block_Check
                          }
                        >
                          <CheckList
                            id={"isTyped"}
                            name={"isTyped"}
                            checked={isTyped}
                            text={"Можно пройти типирование"}
                            type={"checkbox"}
                            onChange={this.typedChange}
                          />
                        </div>
                        <div
                          className={
                            styles.BloodStations_Div_Left_Block_Filters_Block_Check
                          }
                        >
                          <CheckList
                            id={"isSaturday"}
                            name={"isSaturday"}
                            checked={isSaturday}
                            text={"Работают в СБ"}
                            type={"checkbox"}
                            onChange={this.saturdayChange}
                          />
                        </div>
                        <div
                          className={
                            styles.BloodStations_Div_Left_Block_Filters_Block_Check
                          }
                        >
                          <CheckList
                            id={"isSunday"}
                            name={"isSunday"}
                            checked={isSunday}
                            text={"Работают в ВС"}
                            type={"checkbox"}
                            onChange={this.sundayChange}
                          />
                        </div>
                        {isMoscow && (
                          <div
                            className={
                              styles.BloodStations_Div_Left_Block_Filters_Block_Check
                            }
                          >
                            <CheckList
                              id={"isHonoraryDonor"}
                              name={"isHonoraryDonor"}
                              checked={isHonoraryDonor}
                              text={"Почетный донор Москвы"}
                              type={"checkbox"}
                              onChange={this.honoraryDonorChange}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  }
                </div>
                {
                  bloodStations && bloodStations.length > 0 ?
                  <BlockContainer
                    isLink={false}
                    linkUrl={""}
                    linkText={"Все потребности"}
                    isGrid
                    marginTop={10}
                    marginBottom={10}
                    marginTopMobile={20}
                    isMobile={this.props.uiStore?.isMobile}
                    isSSR={false}
                  >
                    <CustomCarousel
                      responsive={this.responsive}
                      removeArrowOnDeviceType={["mobile"]}
                      removeDotsOnDeviceType={["mobile"]}
                      swipeable={true}
                      draggable={true}
                      infinite={true}
                      partialVisible={true}
                      className={bloodStations.length === 1 && styles.mobileOneElement}
                    >
                      {this.content(bloodStations)}
                    </CustomCarousel>
                  </BlockContainer>
                  : <div className={styles.BloodStations_NotFound}>
                      {loaded && <p>Центры крови по вашему запросу не найдены, выберите другой город или сбросьте фильтры</p>}
                    </div>
                }
              </div>
              </div>
              <div className={styles.BloodStations_Div_Right}>
                {!isMapLoaded && <Spinner toggled={true} onAll={true} />}
                <Ymaps
                  mapBounds={mapBounds}
                  currentMapBounds={this.state.currentMapBounds}
                  isMobile={false}
                  mapRef={this.mapRef}
                  placemarkRefs={this.placemarkRefs}
                  mobileOpenPopup={this.mobileOpenPopup}
                  mapLoaded={this.mapLoaded}
                  boundsMoving={this.boundsMoving}
                  mapGeolocationClick={this.mapGeolocationClick}
                  bloodStations={bloodStations}
                  defaultCity={this.state.defaultCity}
                  onBoundsChange={this.onBoundsChange}
                />
              </div>
            </div>
          </div>
        </>
      );
    else return null;
  }
}

export default withRouter(BloodStationsPage);

export const CheckList = ({ id, text, checked, onChange, type, name }) => {
  return (
    <label key={id} htmlFor={id}>
      <input
        type={type}
        name={name}
        id={id}
        checked={checked}
        onChange={() => {
          onChange(name, id, !checked);
        }}
        hidden
      />
      <div />
      <span>{text}</span>
    </label>
  );
};

const MobileFilter = ({
  bloodStations,
  isRegistration,
  registrationChange,
  isTyped,
  typedChange,
  isSaturday,
  saturdayChange,
  isSunday,
  sundayChange,
  isMoscow,
  isHonoraryDonor,
  honoraryDonorChange,
  clearFilters
}) => {
  const [isOpenFilterMobile, setOpenFilterMobile] = useState(false);

  return (
    <div
      className={
        styles.BloodStations_Div_Left_Block_Filters_Block
      }
    >
      <div
        className={
          styles.BloodStations_Div_Left_Block_Filters_Block_Header
        }
      >
        <div
          className={`
            ${styles.BloodStations_Div_Left_Block_Filters_Block_Header_Selected}
          `}
        >
          { isOpenFilterMobile &&
            (bloodStations && bloodStations?.length ? (
              <span>
                {plural(
                  bloodStations.length,
                  "Центр крови",
                  "Центра крови",
                  "Центров крови"
                )}
                <span> {bloodStations.length}</span>
              </span>
            ) : (
              <span>
                Центров крови <span>0</span>
              </span>
            ))
          }
        </div>
        {
          !isOpenFilterMobile ?
          <div
            onClick={() => setOpenFilterMobile(!isOpenFilterMobile)}
            className={
              styles.BloodStations_Div_Left_Block_Filters_Block_Header_Clean
            }
          >
            <span>Показать фильтры</span>
          </div>
          :
          <div
            onClick={clearFilters}
            className={
              styles.BloodStations_Div_Left_Block_Filters_Block_Header_Clean
            }
          >
            <span>Сбросить фильтры</span>
          </div>
        }
      </div>
      { isOpenFilterMobile &&
      <div className={styles.BloodStations_Div_Left_Block_Filters_List}>
        <div
          className={
            styles.BloodStations_Div_Left_Block_Filters_Block_Check
          }
        >
          <CheckList
            id={"isRegistration"}
            name={"isRegistration"}
            checked={isRegistration}
            text={"Можно сдавать без прописки"}
            type={"checkbox"}
            onChange={registrationChange}
          />
        </div>
        <div
          className={
            styles.BloodStations_Div_Left_Block_Filters_Block_Check
          }
        >
          <CheckList
            id={"isTyped"}
            name={"isTyped"}
            checked={isTyped}
            text={"Можно пройти типирование"}
            type={"checkbox"}
            onChange={typedChange}
          />
        </div>
        <div
          className={
            styles.BloodStations_Div_Left_Block_Filters_Block_Check
          }
        >
          <CheckList
            id={"isSaturday"}
            name={"isSaturday"}
            checked={isSaturday}
            text={"Работают в СБ"}
            type={"checkbox"}
            onChange={saturdayChange}
          />
        </div>
        <div
          className={
            styles.BloodStations_Div_Left_Block_Filters_Block_Check
          }
        >
          <CheckList
            id={"isSunday"}
            name={"isSunday"}
            checked={isSunday}
            text={"Работают в ВС"}
            type={"checkbox"}
            onChange={sundayChange}
          />
        </div>
        {isMoscow && (
          <div
            className={
              styles.BloodStations_Div_Left_Block_Filters_Block_Check
            }
          >
            <CheckList
              id={"isHonoraryDonor"}
              name={"isHonoraryDonor"}
              checked={isHonoraryDonor}
              text={"Почетный донор Москвы"}
              type={"checkbox"}
              onChange={honoraryDonorChange}
            />
          </div>
        )}
      </div>
      }
      {
        isOpenFilterMobile &&
        <div
          onClick={() => setOpenFilterMobile(false)}
          className={
            styles.BloodStations_Div_Left_Block_Filters_Block_Header_Close
          }
        >
          <span>Свернуть фильтры</span>
        </div>
      }
    </div>
  )
}
